import React from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { FormattedMessage } from "react-intl";

import Table from "components/Table";
import FieldChooser from "components/FieldChooser";
import TopButtons from "components/TopButtons";
import areaStatementViewActions from "./actions";
import { markAsRead, markAsUnread } from "../app/actions";
import { downloadDocuments } from "helpers/download";
import { getSelectedData } from "helpers/common";
import { columnsExcel } from "../orders/columnsExcel";
import { CUSTOM_SETTINGS } from "constants/index";
import { columns } from "./columns";
import AreaStatementSearch from "./partials/areaStatementSearch";

class AreaStatementView extends React.Component<any, any> {
  constructor(props) {
    super(props);

    this.state = {
      selectedOption: "",
      showFieldChooser: false,
      columnsCopy: [],
      checkedRows: {},
      selectedData: [],
    };
  }

  public handleSelect = (selectedOption) => {
    const { selectedData } = this.state;
    const { value } = selectedOption;
    const ids = _.map(selectedData, "orderId");

    value === "gelezen" && markAsRead(ids);
    value === "ongelezen" && markAsUnread(ids);
    if (value === "pdf") {
      const documentIds = _.compact(_.map(selectedData, "documentId"));
      downloadDocuments(documentIds, "AREA_STATEMENT");
      markAsRead(ids);
    }
  };

  public handleFieldChooser = () => {
    this.setState(({ showFieldChooser }) => ({
      showFieldChooser: !showFieldChooser,
    }));
  };

  public handleFieldsChange = (data) => {
    this.setState({ columnsCopy: data });
  };

  private onRowSelect = (checkedRows) => {
    this.setState({
      checkedRows,
      selectedData: getSelectedData(
        this.props.areaStatements,
        checkedRows,
        this.state.selectedData,
        "orderId"
      ),
    });
  };

  private extractMinAndMaxYears = (areaStatements) => {
    const years = areaStatements.map((areaStatement) => {
      return areaStatement.AreaStatement.HarvestYear;
    });
    const minYear = Math.min(...years);
    const maxYear = Math.max(...years);
    return { minYear, maxYear };
  };

  public render() {
    const {
      areaStatements,
      getAreaStatements,
      meta,
      roleIds,
      statusOptions,
      typeOptions,
    } = this.props;
    const { showFieldChooser, columnsCopy, selectedOption, checkedRows } =
      this.state;
    const yearRange = this.extractMinAndMaxYears(areaStatements);

    return (
      <div id="orders-page">
        <FormattedMessage id="AREA_STATEMENT" tagName="h1" />
        <AreaStatementSearch
          meta={meta}
          onSearch={getAreaStatements}
          roleIds={roleIds}
          typeOptions={typeOptions}
          statusOptions={statusOptions}
          yearRange={yearRange}
        />
        <TopButtons
          switchUnread={meta.unread}
          handleFieldChooser={this.handleFieldChooser}
          handleSelect={this.handleSelect}
          toggleUnread={() =>
            getAreaStatements({
              ...meta,
              unread: !meta.unread,
              currentPage: 0,
            })
          }
          excelColumns={columnsExcel}
          selectedOption={selectedOption}
          entityName="AREA_STATEMENT"
        />
        <Table
          columns={columnsCopy}
          dataSource={areaStatements}
          meta={meta}
          onQueryChange={getAreaStatements}
          onRowSelect={this.onRowSelect}
          checkedRows={checkedRows}
          pageName={CUSTOM_SETTINGS.areaStatements}
        />
        <FieldChooser
          name="areaalopgaven"
          visible={showFieldChooser}
          handleFieldChooser={this.handleFieldChooser}
          handleFieldsChange={this.handleFieldsChange}
          columns={columns}
        />
      </div>
    );
  }
}

export default connect(
  (state) => ({
    areaStatements: state.areaStatements.items,
    meta: state.areaStatements.meta,
    roleIds: state.app.roleIds,
    statusOptions: state.areaStatements.statusOptions,
    typeOptions: state.areaStatements.typeOptions,
  }),
  {
    getAreaStatements: areaStatementViewActions.getAreaStatements,
  }
)(AreaStatementView);
